import { render } from "./AdminStudents.vue?vue&type=template&id=a3bb775c"
import script from "./AdminStudents.vue?vue&type=script&lang=js"
export * from "./AdminStudents.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__